const englishTranslation = {
    translation: {
        "en": "ENGLISH",
        "sp": "SPANISH",
        "jp": "JAPANESE",
        "brand": "DIEGO",
        "about": "ABOUT",
        "experience": "EXPERIENCE",
        "projects": "PROJECTS",
        "carrier": "SOFTWARE ENGINEER",
        "cv": "RESUME",
        "cv-pdf": "./assets/docs/BTDF_CV_ENG.pdf",
        "salutate": 'Hi, I am',
        "full-name": "Diego Fernando Trenado",
        "goal":"I am a Full Stack Developer, Maker, and Computer Systems Engineer based in Mexico. I am passionate about designing, developing, and optimizing web applications. Currently, I am building scalable, reliable products using several cloud services, while also enhancing the aesthetics, performance, and functionality of websites across various projects.",
        "contact": 'CONTACT',
        "hire": 'HIRE',
        "about-title": "About",
        "about-me-1": 'Hi my name is Diego and I am very passionate about programming and designing. I started building things for the web since 2017 as a hobby.',
        "about-me-2": 'I have had the opportunity to work with different companies in order to learn and improve my skills.  I am a result-oriented person who always tries to come up with the best solution for each project.',
        "about-me-3": 'These are some of the technologies I work with today.',
        "about-me": `I am a Software Engineer with experience in Frontend, Backend, Mobile and Desktop development. I have professional experience developing web apps.
        I like to connect and create interfaces between real and digital world. I develop functional and appealing systems and UI.`,
        "tech-stack": "MY TECH STACK",
        "contact-me": "CONTACT",
        "email": "Email",
        "name": "Name",
        "message": "Message",
        "send": "SEND",
        "reset": "RESET",
        "developed": "Developed by",

        "recent-projects": "RECENT PROJECTS",

        "name-project-1": "Encargamelo. Online orders for restaurants",
        "tech-project-1": "Firebase, Cloud Firestone, React, Tailwind CSS",
        "description-project-1": "Platform that allows restaurants to manage and publish their menus, and customers to place orders directly on the restaurant's specific menu page.",
        "img-project-1": "/assets/images/projects/encargamelo.png",
        "github-project-1": "https://github.com/SakugaCoder/Automotive-parts-detection",

        "name-project-2": "Documet manager system",
        "tech-project-2": "Python, Flask, MySQL, Ubuntu Server, React, Styled-Components",
        "description-project-2": "Web platform to manage business documents, with a role and permission system, and a control panel for user and document management.",
        "img-project-2": "/assets/images/projects/Dashboard.jpg",
        "github-project-2": "https://github.com/SakugaCoder/GloveController",

        "name-project-3": "AI chatbot for tire sales",
        "tech-project-3": "Lambda, API Gateway, Facebok Cloud API, OpenAI Assistant API, Python",
        "description-project-3": "WhatsApp-based assistant to manage and promote tire sales, using a Serverless architecture, the OpenAI Assistant API, and the Facebook Cloud API.",
        "img-project-3": "/assets/images/projects/chat.png",
        "github-project-3": "https://github.com/SakugaCoder/ThingsToBuy-ReactJS"
    }
};

export default englishTranslation;